import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const ChartLineIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
        width={20}
        height={20}
        viewBox='0 0 24 24'
        fill='currentColor'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
        ref={ref}
    >
        <path d='m16 11.78 4.24-7.33 1.73 1-5.23 9.05-6.51-3.75L5.46 19H22v2H2V3h2v14.54L9.5 8l6.5 3.78Z'/>
    </svg>
));
